import { render, staticRenderFns } from "./ImprimiblesReceta.vue?vue&type=template&id=3c6d248e"
import script from "./ImprimiblesReceta.vue?vue&type=script&lang=js"
export * from "./ImprimiblesReceta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports